module.exports = __webpack_public_path__ + "static/media/mechanism.c3ff4076.png";